import { put, takeLatest } from 'redux-saga/effects';
import { signup, getAdmins, signin, success, failed } from '../slice/userSlice';
import { postRequest, getRequest, deleteRequest, putRequest } from './ApiInstence';
import { toast } from 'react-toastify';
import { getContactUs, successContactUs, failedContactUs, removeContactUs, getDashboardData } from '../slice/contactUsSlice';
import { 
  getEnquire, 
  removeEnquire, 
  updateEnquire, 
  getOneEnquire, 
  successEnquire, 
  successOneEnquire, 
} from '../slice/enquireSlice';
import {
  getGalleries,
  addGallery,
  updateGallery,
  removeGallery,
  getOneGallery,
  successGallery,
  successOneGallery,
  failedGallery
} from '../slice/gallerySlice';
import { getBanner, successBanner, removeBanner, addBanner, getOneBanner, updateBanner, successOneBanner, failedBanner } from '../slice/bannerSlice';
import {
  getPackages,
  addPackage,
  updatePackage,
  removePackage,
  getOnePackage,
  successPackage,
  successOnePackage,
  failedPackage
} from '../slice/khajurahoPackageSlice';
import {
  getServices,
  addService,
  updateService,
  removeService,
  getOneService,
  successService,
  successOneService,
  failedService
} from '../slice/serviceSlice';
import {
  getItineraries,
  addItinerary,
  updateItinerary,
  removeItinerary,
  successItinerary,
  failedItinerary
} from '../slice/itinerarySlice';
import {
  getTestimonials,
  addTestimonial,
  updateTestimonial,
  removeTestimonial,
  getOneTestimonial,
  successTestimonial,
  successOneTestimonial,
  failedTestimonial
} from '../slice/testimonialSlice';
import {
  getVideos,
  addVideo,
  updateVideo,
  removeVideo,
  getOneVideo,
  successVideo,
  successOneVideo,
  failedVideo
} from '../slice/videoSlice';
import {
  getVisits,
  addVisit,
  updateVisit,
  removeVisit,
  getOneVisit,
  successVisit,
  successOneVisit,
  failedVisit
} from '../slice/visitSlice';
import {
  getBookings,
  updateBooking,
  removeBooking,
  getOneBooking,
  successBooking,
  successOneBooking,
  failedBooking
} from '../slice/bookingSlice';

const multipartFormHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

// Auth
function* signinUser({ payload }) {
  try {
    let response = yield postRequest('admin/signin', payload, {
      withCredentials: true,
    });
    if (response?.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}

function* signupUser({ payload }) {
  try {
    const response = yield postRequest('admin/signup', payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failed(error));
  }
}

function* getAdminsUser() {
  try {
    const response = yield getRequest('admin');
    if (response?.status === 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error);
  }
}

// Contact Us
function* getContactUsFun({ payload }) {
  try {
    const response = yield getRequest('contactus', payload);
    if (response?.status === 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* removeContactUsFun({ payload }) {
  try {
    const response = yield deleteRequest(`contactus/${payload}`);
    if (response?.status === 200) {
      yield getContactUsFun({ payload });
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* getDashboardDataFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status === 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
  }
}


// Banner
function* getBannerFun() {
  try {
    const response = yield getRequest('banner');
    if (response?.status === 200) {
      yield put(successBanner(response?.data?.data));
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to fetch banners'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedBanner(error.message));
  }
}

function* addBannerFun({ payload }) {
  try {
    const response = yield postRequest(`banner`, payload, multipartFormHeaders);
    if (response?.status === 200) {
      yield getBannerFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* removeBannerFun({ payload }) {
  try {
    const response = yield deleteRequest(`banner/${payload}`);
    if (response?.status === 200) {
      toast.success('Banner deleted successfully');
      yield getBannerFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* getOneBannerFun({ payload }) {
  try {
    const response = yield getRequest(`banner/${payload}`);
    if (response?.status === 200) {
      yield put(successOneBanner(response?.data?.data));
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to fetch banner'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedBanner(error.message));
  }
}

function* updateBannerFun({ payload }) {
  try {
    const response = yield putRequest(`banner/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200) {
      toast.success('Banner updated successfully');
      yield getBannerFun();
    } else {
      yield put(failedBanner(response?.data?.message || 'Failed to update banner'));
    }
  } catch (error) {
    console.log(error);
    yield put(failedBanner(error.message));
  }
}

// Enquire
function* getEnquireFun({ payload }) {
  try {
    const response = yield getRequest('enquiries', payload);
    if (response?.status === 200) {
      yield put(successEnquire(response?.data?.data));
    }
  } catch (error) {
    console.log(error);
  }
}

function* removeEnquireFun({ payload }) {
  try {
    const response = yield deleteRequest(`enquiries/${payload}`);
    if (response?.status === 200) {
      toast.success('Enquiry deleted successfully');
      yield getEnquireFun({ payload });
    }
  } catch (error) {
    console.log(error);
  }
}

function* updateEnquireFun({ payload }) {
  const { id, data } = payload;
  try {
    const response = yield putRequest(`enquiries/${id}`, data);
    if (response?.status === 200) {
      toast.success('Enquiry updated successfully');
      yield getEnquireFun({ payload });
    }
  } catch (error) {
    console.log(error);
  }
}

function* getOneEnquireFun({ payload }) {
  try {
    const response = yield getRequest(`enquiries/${payload}`);
    if (response?.status === 200) {
      yield put(successOneEnquire(response?.data?.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// Khajuraho Packages
function* getPackagesFun() {
  try {
    const response = yield getRequest('packages');
    if (response?.status === 200) {
      yield put(successPackage(response?.data?.data));
    } else {
      yield put(failedPackage(response));
    }
  } catch (error) {
    yield put(failedPackage(error));
  }
}

function* addPackageFun({ payload }) {
  try {
    const response = yield postRequest('packages', payload, multipartFormHeaders);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success('Package added successfully');
      yield getPackagesFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* updatePackageFun({ payload }) {
  try {
    const response = yield putRequest(`packages/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200 || response?.status === 201) {
      toast.success('Package updated successfully');
      yield getPackagesFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* removePackageFun({ payload }) {
  try {
    const response = yield deleteRequest(`packages/${payload}`);
    if (response?.status === 200) {
      toast.success('Package deleted successfully');
      yield getPackagesFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* getOnePackageFun({ payload }) {
  try {
    const response = yield getRequest(`packages/${payload}`);
    if (response?.status === 200) {
      yield put(successOnePackage(response?.data?.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// Itinerary
function* getItinerariesFun({ payload }) {
  try {
    const response = yield getRequest(`itineraries/${payload}`);
    if (response?.status === 200) {
      yield put(successItinerary(response?.data?.data));
    } else {
      yield put(failedItinerary(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedItinerary(error.message));
  }
}

function* addItineraryFun({ payload }) {
  try {
    const response = yield postRequest('itineraries', payload);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Day added!');
      yield getItinerariesFun({ payload: payload.packageId });
    } else {
      yield put(failedItinerary(response?.data?.message || 'Failed to add'));
    }
  } catch (error) {
    yield put(failedItinerary(error.message));
  }
}

function* updateItineraryFun({ payload }) {
  try {
    const response = yield putRequest(`itineraries/${payload.id}`, payload.data);
    if (response?.status === 200 || response?.status === 201) {
      toast.success('Day updated!');
      yield getItinerariesFun({ payload: payload.packageId });
    } else {
      yield put(failedItinerary(response?.data?.message || 'Failed to update'));
    }
  } catch (error) {
    yield put(failedItinerary(error.message));
  }
}

function* removeItineraryFun({ payload }) {
  try {
    const response = yield deleteRequest(`itineraries/${payload.id}`);
    if (response?.status === 200) {
      toast.success('Day deleted!');
      yield getItinerariesFun({ payload: payload.packageId });
    } else {
      yield put(failedItinerary(response?.data?.message || 'Failed to delete'));
    }
  } catch (error) {
    yield put(failedItinerary(error.message));
  }
}

// Testimonials
function* getTestimonialsFun() {
  try {
    const response = yield getRequest('testimonial');
    if (response?.status === 200) {
      yield put(successTestimonial(response?.data?.data));
    } else {
      yield put(failedTestimonial(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedTestimonial(error.message));
  }
}

function* addTestimonialFun({ payload }) {
  try {
    const response = yield postRequest('testimonial', payload, multipartFormHeaders);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Testimonial added successfully');
      yield getTestimonialsFun();
    } else {
      yield put(failedTestimonial(response?.data?.message || 'Failed to add'));
    }
  } catch (error) {
    yield put(failedTestimonial(error.message));
  }
}

function* updateTestimonialFun({ payload }) {
  try {
    const response = yield putRequest(`testimonial/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200) {
      toast.success('Testimonial updated successfully');
      yield getTestimonialsFun();
    } else {
      yield put(failedTestimonial(response?.data?.message || 'Failed to update'));
    }
  } catch (error) {
    yield put(failedTestimonial(error.message));
  }
}

function* removeTestimonialFun({ payload }) {
  try {
    const response = yield deleteRequest(`testimonial/${payload}`);
    if (response?.status === 200) {
      toast.success('Testimonial deleted successfully');
      yield getTestimonialsFun();
    } else {
      yield put(failedTestimonial(response?.data?.message || 'Failed to delete'));
    }
  } catch (error) {
    yield put(failedTestimonial(error.message));
  }
}

function* getOneTestimonialFun({ payload }) {
  try {
    const response = yield getRequest(`testimonial/${payload}`);
    if (response?.status === 200) {
      yield put(successOneTestimonial(response?.data?.data));
    } else {
      yield put(failedTestimonial(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedTestimonial(error.message));
  }
}

// Videos
function* getVideosFun() {
  try {
    const response = yield getRequest('videos');
    if (response?.status === 200) {
      yield put(successVideo(response?.data?.data));
    } else {
      yield put(failedVideo(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedVideo(error.message));
  }
}

function* addVideoFun({ payload }) {
  try {
    const response = yield postRequest('videos', payload, multipartFormHeaders);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Video added successfully');
      yield getVideosFun();
    } else {
      yield put(failedVideo(response?.data?.message || 'Failed to add'));
    }
  } catch (error) {
    yield put(failedVideo(error.message));
  }
}

function* updateVideoFun({ payload }) {
  try {
    const response = yield putRequest(`videos/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200) {
      toast.success('Video updated successfully');
      yield getVideosFun();
    } else {
      yield put(failedVideo(response?.data?.message || 'Failed to update'));
    }
  } catch (error) {
    yield put(failedVideo(error.message));
  }
}

function* removeVideoFun({ payload }) {
  try {
    const response = yield deleteRequest(`videos/${payload}`);
    if (response?.status === 200) {
      toast.success('Video deleted successfully');
      yield getVideosFun();
    } else {
      yield put(failedVideo(response?.data?.message || 'Failed to delete'));
    }
  } catch (error) {
    yield put(failedVideo(error.message));
  }
}

function* getOneVideoFun({ payload }) {
  try {
    const response = yield getRequest(`videos/${payload}`);
    if (response?.status === 200) {
      yield put(successOneVideo(response?.data?.data));
    } else {
      yield put(failedVideo(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedVideo(error.message));
  }
}

// Visits
function* getVisitsFun() {
  try {
    const response = yield getRequest('visits');
    if (response?.status === 200) {
      yield put(successVisit(response?.data?.data));
    } else {
      yield put(failedVisit(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedVisit(error.message));
  }
}

function* addVisitFun({ payload }) {
  try {
    const response = yield postRequest('visits', payload, multipartFormHeaders);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Visit added successfully');
      yield getVisitsFun();
    } else {
      yield put(failedVisit(response?.data?.message || 'Failed to add'));
    }
  } catch (error) {
    yield put(failedVisit(error.message));
  }
}

function* updateVisitFun({ payload }) {
  try {
    const response = yield putRequest(`visits/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200) {
      toast.success('Visit updated successfully');
      yield getVisitsFun();
    } else {
      yield put(failedVisit(response?.data?.message || 'Failed to update'));
    }
  } catch (error) {
    yield put(failedVisit(error.message));
  }
}

function* removeVisitFun({ payload }) {
  try {
    const response = yield deleteRequest(`visits/${payload}`);
    if (response?.status === 200) {
      toast.success('Visit deleted successfully');
      yield getVisitsFun();
    } else {
      yield put(failedVisit(response?.data?.message || 'Failed to delete'));
    }
  } catch (error) {
    yield put(failedVisit(error.message));
  }
}

function* getOneVisitFun({ payload }) {
  try {
    const response = yield getRequest(`visits/${payload}`);
    if (response?.status === 200) {
      yield put(successOneVisit(response?.data?.data));
    } else {
      yield put(failedVisit(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedVisit(error.message));
  }
}

// Gallery
function* getGalleriesFun() {
  try {
    const response = yield getRequest('gallery');
    if (response?.status === 200) {
      yield put(successGallery(response?.data?.data));
    } else {
      yield put(failedGallery(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedGallery(error.message));
  }
}

function* addGalleryFun({ payload }) {
  try {
    const response = yield postRequest('gallery', payload, multipartFormHeaders);
    if (response?.status === 201 || response?.status === 200) {
      toast.success('Gallery item added successfully');
      yield getGalleriesFun();
    } else {
      yield put(failedGallery(response?.data?.message || 'Failed to add'));
    }
  } catch (error) {
    yield put(failedGallery(error.message));
  }
}

function* updateGalleryFun({ payload }) {
  try {
    const response = yield putRequest(`gallery/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200) {
      toast.success('Gallery item updated successfully');
      yield getGalleriesFun();
    } else {
      yield put(failedGallery(response?.data?.message || 'Failed to update'));
    }
  } catch (error) {
    yield put(failedGallery(error.message));
  }
}

function* removeGalleryFun({ payload }) {
  try {
    const response = yield deleteRequest(`gallery/${payload}`);
    if (response?.status === 200) {
      toast.success('Gallery item deleted successfully');
      yield getGalleriesFun();
    } else {
      yield put(failedGallery(response?.data?.message || 'Failed to delete'));
    }
  } catch (error) {
    yield put(failedGallery(error.message));
  }
}

function* getOneGalleryFun({ payload }) {
  try {
    const response = yield getRequest(`gallery/${payload}`);
    if (response?.status === 200) {
      yield put(successOneGallery(response?.data?.data));
    } else {
      yield put(failedGallery(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedGallery(error.message));
  }
}

// Services
function* getServicesFun() {
  try {
    const response = yield getRequest('service');
    if (response?.status === 200) {
      yield put(successService(response?.data?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    yield put(failedService(error));
  }
}

function* addServiceFun({ payload }) {
  try {
    const response = yield postRequest('service', payload, multipartFormHeaders);
    if (response?.status >= 200 && response?.status < 300) {
      toast.success('Service added successfully');
      yield getServicesFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* updateServiceFun({ payload }) {
  try {
    const response = yield putRequest(`service/${payload.id}`, payload.data, multipartFormHeaders);
    if (response?.status === 200) {
      toast.success('Service updated successfully');
      yield getServicesFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* removeServiceFun({ payload }) {
  try {
    const response = yield deleteRequest(`service/${payload}`);
    if (response?.status === 200) {
      toast.success('Service deleted successfully');
      yield getServicesFun();
    }
  } catch (error) {
    console.log(error);
  }
}

function* getOneServiceFun({ payload }) {
  try {
    const response = yield getRequest(`service/${payload}`);
    if (response?.status === 200) {
      yield put(successOneService(response?.data?.data));
    } else {
      yield put(failedService(response));
    }
  } catch (error) {
    console.log(error);
  }
}

// Bookings
function* getBookingsFun() {
  try {
    const response = yield getRequest('bookings');
    if (response?.status === 200) {
      yield put(successBooking(response?.data?.data));
    } else {
      yield put(failedBooking(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedBooking(error.message));
  }
}

function* updateBookingFun({ payload }) {
  const { id, data } = payload;
  try {
    const response = yield putRequest(`bookings/${id}`, data);
    if (response?.status === 200) {
      toast.success('Booking status updated successfully');
      yield getBookingsFun();
    } else {
      yield put(failedBooking(response?.data?.message || 'Failed to update'));
    }
  } catch (error) {
    yield put(failedBooking(error.message));
  }
}

function* removeBookingFun({ payload }) {
  try {
    const response = yield deleteRequest(`bookings/${payload}`);
    if (response?.status === 200) {
      toast.success('Booking deleted successfully');
      yield getBookingsFun();
    } else {
      yield put(failedBooking(response?.data?.message || 'Failed to delete'));
    }
  } catch (error) {
    yield put(failedBooking(error.message));
  }
}

function* getOneBookingFun({ payload }) {
  try {
    const response = yield getRequest(`khajuraho/bookings/${payload}`);
    if (response?.status === 200) {
      yield put(successOneBooking(response?.data?.data));
    } else {
      yield put(failedBooking(response?.data?.message || 'Failed'));
    }
  } catch (error) {
    yield put(failedBooking(error.message));
  }
}

// Watcher
export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);
  yield takeLatest(getAdmins, getAdminsUser);

  // Dashboard & Contact
  yield takeLatest(getContactUs, getContactUsFun);
  yield takeLatest(removeContactUs, removeContactUsFun);
  yield takeLatest(getDashboardData, getDashboardDataFun);

  // Khajuraho Packages
  yield takeLatest(getPackages, getPackagesFun);
  yield takeLatest(addPackage, addPackageFun);
  yield takeLatest(updatePackage, updatePackageFun);
  yield takeLatest(removePackage, removePackageFun);
  yield takeLatest(getOnePackage, getOnePackageFun);

  // Itinerary
  yield takeLatest(getItineraries, getItinerariesFun);
  yield takeLatest(addItinerary, addItineraryFun);
  yield takeLatest(updateItinerary, updateItineraryFun);
  yield takeLatest(removeItinerary, removeItineraryFun);

  // Testimonials
  yield takeLatest(getTestimonials, getTestimonialsFun);
  yield takeLatest(addTestimonial, addTestimonialFun);
  yield takeLatest(updateTestimonial, updateTestimonialFun);
  yield takeLatest(removeTestimonial, removeTestimonialFun);
  yield takeLatest(getOneTestimonial, getOneTestimonialFun);

  // Videos
  yield takeLatest(getVideos, getVideosFun);
  yield takeLatest(addVideo, addVideoFun);
  yield takeLatest(updateVideo, updateVideoFun);
  yield takeLatest(removeVideo, removeVideoFun);
  yield takeLatest(getOneVideo, getOneVideoFun);

  // Visits
  yield takeLatest(getVisits, getVisitsFun);
  yield takeLatest(addVisit, addVisitFun);
  yield takeLatest(updateVisit, updateVisitFun);
  yield takeLatest(removeVisit, removeVisitFun);
  yield takeLatest(getOneVisit, getOneVisitFun);

  // Gallery
  yield takeLatest(getGalleries, getGalleriesFun);
  yield takeLatest(addGallery, addGalleryFun);
  yield takeLatest(updateGallery, updateGalleryFun);
  yield takeLatest(removeGallery, removeGalleryFun);
  yield takeLatest(getOneGallery, getOneGalleryFun);

  // Services
  yield takeLatest(getServices, getServicesFun);
  yield takeLatest(addService, addServiceFun);
  yield takeLatest(updateService, updateServiceFun);
  yield takeLatest(removeService, removeServiceFun);
  yield takeLatest(getOneService, getOneServiceFun);


  // Banner
  yield takeLatest(getBanner, getBannerFun);
  yield takeLatest(addBanner, addBannerFun);
  yield takeLatest(removeBanner, removeBannerFun);
  yield takeLatest(getOneBanner, getOneBannerFun);
  yield takeLatest(updateBanner, updateBannerFun);

  // Enquiries
  yield takeLatest(getEnquire, getEnquireFun);
  yield takeLatest(removeEnquire, removeEnquireFun);
  yield takeLatest(updateEnquire, updateEnquireFun);
  yield takeLatest(getOneEnquire, getOneEnquireFun);

  // Bookings
  yield takeLatest(getBookings, getBookingsFun);
  yield takeLatest(updateBooking, updateBookingFun);
  yield takeLatest(removeBooking, removeBookingFun);
  yield takeLatest(getOneBooking, getOneBookingFun);
}
